<div class="p-4">
  <p-toast></p-toast>
  <p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>
  <div class="loader-overlay" *ngIf="isLoading">
    <p-progress-spinner ariaLabel="loading" />
  </div>

  <div class="card">
    <form [formGroup]="contractForm" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="off">
      <div class="card bg-white border-round">
        <div class="card-header p-3 ml-auto border-bottom-1 border-gray-200">
          <div class="flex items-center inline-block">
            <h2 class="m-0"> Fixed Rebate Request</h2>
          </div>
        </div>
        <div class="card-body p-3 mt-3">
          <div class="grid formgrid p-fluid">
            <!-- contract name required -->
            <div class="field col-12 md:col-6">
              <p-inputgroup>
                <p-inputgroup-addon><i class="pi pi-pencil"></i></p-inputgroup-addon>
                <p-iftalabel>
                  <input type="text" pInputText formControlName="contractName" id="contractName" class="w-full"
                    placeholder="Enter Contract name" [ngClass]="{ 'p-invalid': isInvalid('contractName') }" />
                  <label for="contractName">Contract Name<span class="requiredLable">*</span></label>
                </p-iftalabel>
              </p-inputgroup>
            </div>

            <!-- customer required -->
            <div class="field col-12 md:col-6">
              <p-inputgroup>
                <p-inputgroup-addon><i class="pi pi-users"></i></p-inputgroup-addon>
                <p-iftalabel>
                  <p-dropdown [options]="filteredCustomers" formControlName="customer" inputId="customer"
                    styleClass="w-full" [filter]="true" [fluid]="true"
                    [ngClass]="{ 'p-invalid': isInvalid('customer') }" [panelStyle]="{ width: '70%' }">
                    <ng-template let-customer pTemplate="selectedItem">
                      <div *ngIf="customer">
                        {{ customer.customerNumber }} -
                        {{ customer.customerName }}
                      </div>
                    </ng-template>
                    <ng-template let-customer pTemplate="item">
                      <div>
                        {{ customer.customerNumber }} -
                        {{ customer.customerName }}
                      </div>
                    </ng-template>
                    <ng-template pTemplate="filter" let-customer>
                      <p-inputgroup>
                        <p-inputgroup-addon>
                          <i class="pi pi-search"></i>
                        </p-inputgroup-addon>
                        <input #customerInput type="text" pInputText placeholder="Filter"
                          (keyup)="filterCustomers($event)" value="{{ CustomerfilterValue }}" />
                        <!-- <p-button
                          type="button"
                          icon="pi pi-times"
                          (click)="customer.reset(); customerInput.value = ''"
                          styleClass="p-button-secondary"
                        ></p-button> -->
                      </p-inputgroup>
                    </ng-template>
                  </p-dropdown>
                  <label for="customer">Customer<span class="requiredLable">*</span></label>
                </p-iftalabel>
                <p-inputgroup-addon><p-button type="button" icon="pi pi-times"
                    (click)="contractForm.controls['customer'].reset();"
                    styleClass="p-button-secondary addOnBtnClear"></p-button></p-inputgroup-addon>
              </p-inputgroup>
            </div>

            <!-- start date required -->
            <div class="field col-12 md:col-6">
              <p-inputgroup>
                <p-inputgroup-addon><i class="pi pi-calendar"></i></p-inputgroup-addon>
                <p-iftalabel>
                  <p-datePicker formControlName="startDateActive" [showIcon]="true" inputId="startDateActive"
                    class="w-full" [appendTo]="'body'" [style]="{ width: '100%' }" [minDate]="tomorrowDate"
                    [inputStyleClass]="isInvalid('startDateActive') ? 'p-invalid' : ''"></p-datePicker>
                  <label for="startDateActive">Start Date<span class="requiredLable">*</span></label>
                </p-iftalabel>
              </p-inputgroup>
            </div>

            <!-- end date requird -->
            <div class="field col-12 md:col-6">
              <p-inputgroup>
                <p-inputgroup-addon><i class="pi pi-calendar"></i></p-inputgroup-addon>
                <p-iftalabel>
                  <p-datePicker formControlName="endDateActive" [showIcon]="true" inputId="endDateActive" class="w-full"
                    [appendTo]="'body'" [style]="{ width: '100%' }"
                    [minDate]="contractForm.get('startDateActive')?.value"
                    [inputStyleClass]="isInvalid('endDateActive') ? 'p-invalid' : ''"></p-datePicker>
                  <label for="endDateActive">End Date<span class="requiredLable">*</span></label>
                </p-iftalabel>
              </p-inputgroup>
            </div>

            <!-- note not required -->
            <div class="field col-12">
              <p-inputgroup>
                <p-inputgroup-addon><i class="pi pi-pencil"></i></p-inputgroup-addon>
                <p-iftalabel>
                  <textarea pInputTextarea formControlName="contractNote1" rows="3" class="w-full"
                    inputId="contractNote1" id="contractNote1"></textarea>
                  <label for="contractNote1">Note</label>
                </p-iftalabel>
              </p-inputgroup>
            </div>
          </div>

          <div class="mr-5 flex align-items-center mb-3">
            <i class="pi pi-file-edit mr-2 text-3xl"></i>
            <div class="font-medium text-3xl text-900">Rebate Details</div>
          </div>

          <div class="grid formgrid p-fluid p-3" formArrayName="contractDetails">
            <div *ngFor="let detail of contractDetails.controls; let i = index" [formGroupName]="i"
              class="grid formgrid p-fluid">
              <div class="col-12 md:col-3">
                <p-inputgroup>
                  <p-inputgroup-addon><i class="pi pi-users"></i></p-inputgroup-addon>
                  <p-iftalabel>
                    <p-dropdown [filter]="true" [fluid]="true" [options]="filteredBusinesses" formControlName="business"
                      inputId="business" optionLabel="businessName" styleClass="w-full" placeholder="Select Business"
                      [ngClass]="{ 'p-invalid': isDetailsInvalid(i, 'business') }"
                      (onChange)="onBusinessChange(i, $event.value)" [panelStyle]="{ width: '70%' }">
                      <ng-template let-business pTemplate="selectedItem">
                        <div *ngIf="business">
                          {{ business.businessCode }} -
                          {{ business.businessName }}
                        </div>
                      </ng-template>
                      <ng-template let-business pTemplate="item">
                        <div>
                          {{ business.businessCode }} -
                          {{ business.businessName }}
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-business>
                        <p-inputgroup>
                          <p-inputgroup-addon>
                            <i class="pi pi-search"></i>
                          </p-inputgroup-addon>
                          <input #businessInput type="text" pInputText placeholder="Filter"
                            (keyup)="filterBusinesses($event, i)" [value]="BusinessfilterValue[i] ?? ''" />
                          <!-- <p-button
                            type="button"
                            icon="pi pi-times"
                            (click)="business.reset(); businessInput.value = ''"
                            styleClass="p-button-secondary"
                          ></p-button> -->
                        </p-inputgroup>
                      </ng-template>
                    </p-dropdown>
                    <label for="business">Business <span class="requiredLable">*</span></label>
                  </p-iftalabel>
                  <p-inputgroup-addon><p-button type="button" icon="pi pi-times"
                      (click)="detail.get('business')?.reset()"
                      styleClass="p-button-secondary addOnBtnClear"></p-button></p-inputgroup-addon>
                </p-inputgroup>

              </div>

              <!-- selected Business suppliers -->
              <div class="field col-12 md:col-3">
                <p-inputgroup>
                  <p-inputgroup-addon>
                    <i class="pi pi-building"></i>
                  </p-inputgroup-addon>
                  <p-iftalabel>
                    <p-dropdown [filter]="true" [fluid]="true" [options]="suppliersPerRow[i]" formControlName="vendor"
                      optionLabel="supplierName" inputId="supplier" class="w-full" placeholder="Select Vendor"
                      [ngClass]="{ 'p-invalid': isDetailsInvalid(i, 'vendor') }">
                      <ng-template let-supplier pTemplate="selectedItem">
                        <div *ngIf="supplier">
                          {{ supplier.supplierNumber }} -
                          {{ supplier.supplierName }}
                        </div>
                      </ng-template>

                      <ng-template let-supplier pTemplate="item">
                        <div>
                          {{ supplier.supplierNumber }} -
                          {{ supplier.supplierName }}
                        </div>
                      </ng-template>

                      <ng-template pTemplate="filter" let-supplier>
                        <p-inputgroup>
                          <p-inputgroup-addon>
                            <i class="pi pi-search"></i>
                          </p-inputgroup-addon>
                          <input #supplierInput type="text" pInputText placeholder="Filter"
                            (keyup)="filterSuppliers($event, i)" [value]="SupplierfilterValue[i] ?? '' " />
                          <!-- <p-button
                            type="button"
                            icon="pi pi-times"
                            (click)="supplier.reset(); supplierInput.value = ''"
                            styleClass="p-button-secondary"
                          ></p-button> -->
                        </p-inputgroup>
                      </ng-template>
                    </p-dropdown>
                    <label for="supplier">Supplier<span class="requiredLable">*</span></label>
                  </p-iftalabel>
                  <p-inputgroup-addon><p-button type="button" icon="pi pi-times" (click)="detail.get('vendor')?.reset()"
                      styleClass="p-button-secondary addOnBtnClear"></p-button></p-inputgroup-addon>
                </p-inputgroup>
              </div>

              <!-- REBATE % -->
              <div class="field col-12 md:col-2">
                <p-inputgroup>
                  <p-inputgroup-addon>
                    <i class="pi pi-percentage"></i>
                  </p-inputgroup-addon>
                  <p-iftalabel>
                    <p-inputNumber formControlName="rebate" id="rebate" [min]="0" [max]="100" mode="decimal"
                      [minFractionDigits]="0" [maxFractionDigits]="3" class="w-full" placeholder="Enter Rebate %"
                      [ngClass]="{ 'p-invalid': isDetailsInvalid(i, 'rebate') }"></p-inputNumber>
                    <label for="rebate">REBATE % <span class="requiredLable">*</span></label>
                  </p-iftalabel>
                </p-inputgroup>
              </div>

              <!-- JBP % -->
              <div class="field col-12 md:col-2">
                <p-inputgroup>
                  <p-inputgroup-addon>
                    <i class="pi pi-percentage"></i>
                  </p-inputgroup-addon>
                  <p-iftalabel>
                    <p-inputNumber formControlName="jbpPrc" id="jbp" [min]="0" [max]="100" mode="decimal"
                      [minFractionDigits]="0" [maxFractionDigits]="3" class="w-full" placeholder="Enter JBP %"
                      [ngClass]="{ 'p-invalid': isDetailsInvalid(i, 'jbpPrc') }"></p-inputNumber>
                    <label for="jbp">JBP %<span class="requiredLable">*</span></label>
                  </p-iftalabel>
                </p-inputgroup>
              </div>

              <!-- FIXED JBP -->
              <div class="field col-12 md:col-2">
                <p-inputgroup>
                  <p-inputgroup-addon>
                    <i class="pi pi-lock"></i>
                  </p-inputgroup-addon>
                  <p-iftalabel>
                    <input type="number" pInputText formControlName="fixedJbp" id="fixedJbp" min="0" class="w-full"
                      placeholder="Enter Fixed JBP" [ngClass]="{ 'p-invalid': isDetailsInvalid(i, 'fixedJbp') }" />
                    <label for="fixedJbp">FIXED JBP<span class="requiredLable">*</span></label>
                  </p-iftalabel>
                </p-inputgroup>
              </div>

              <!-- SLAB 1 -->
              <div class="field col-12 md:col-2">
                <p-inputgroup>
                  <p-inputgroup-addon>
                    <i class="pi pi-list"></i>
                  </p-inputgroup-addon>
                  <p-iftalabel>
                    <input type="number" pInputText formControlName="progressiveSlap1" id="progressiveSlap1" min="0"
                      class="w-full" placeholder="Enter Slab 1"
                      [ngClass]="{ 'p-invalid': isDetailsInvalid(i, 'progressiveSlap1') }" />
                    <label for="progressiveSlap1">SLAB 1<span class="requiredLable">*</span></label>
                  </p-iftalabel>
                </p-inputgroup>
              </div>

              <!-- SLAB 1 % -->
              <div class="field col-12 md:col-2">
                <p-inputgroup>
                  <p-inputgroup-addon>
                    <i class="pi pi-percentage"></i>
                  </p-inputgroup-addon>
                  <p-iftalabel>
                    <p-inputNumber formControlName="progressiveSlap1Prc" id="progressiveSlap1Prc" [min]="0" [max]="100"
                      mode="decimal" [minFractionDigits]="0" [maxFractionDigits]="3" class="w-full"
                      placeholder="Enter Slab 1 %"
                      [ngClass]="{ 'p-invalid': isDetailsInvalid(i, 'progressiveSlap1Prc') }"></p-inputNumber>
                    <label for="progressiveSlap1Prc">SLAB 1 %<span class="requiredLable">*</span></label>
                  </p-iftalabel>
                </p-inputgroup>
              </div>

              <!-- SLAB 2 -->
              <div class="field col-12 md:col-2">
                <p-inputgroup>
                  <p-inputgroup-addon>
                    <i class="pi pi-list"></i>
                  </p-inputgroup-addon>
                  <p-iftalabel>
                    <input type="number" pInputText min="0" formControlName="progressiveSlap2" id="progressiveSlap2"
                      class="w-full" placeholder="Enter Slab 2"
                      [ngClass]="{ 'p-invalid': isDetailsInvalid(i, 'progressiveSlap2') }" />
                    <label for="progressiveSlap2">SLAB 2<span class="requiredLable">*</span></label>
                  </p-iftalabel>
                </p-inputgroup>
              </div>

              <!-- SLAB 2 % -->
              <div class="field col-12 md:col-2">
                <p-inputgroup>
                  <p-inputgroup-addon>
                    <i class="pi pi-percentage"></i>
                  </p-inputgroup-addon>
                  <p-iftalabel>
                    <p-inputNumber formControlName="progressiveSlap2Prc" id="progressiveSlap2Prc" [min]="0" [max]="100"
                      mode="decimal" [minFractionDigits]="0" [maxFractionDigits]="3" class="w-full"
                      placeholder="Enter Slab 2 %"
                      [ngClass]="{ 'p-invalid': isDetailsInvalid(i, 'progressiveSlap2Prc') }"></p-inputNumber>
                    <label for="progressiveSlap2Prc">SLAB 2 %<span class="requiredLable">*</span></label>
                  </p-iftalabel>
                </p-inputgroup>
              </div>

              <!-- SLAB 3 -->
              <div class="field col-12 md:col-2">
                <p-inputgroup>
                  <p-inputgroup-addon>
                    <i class="pi pi-list"></i>
                  </p-inputgroup-addon>
                  <p-iftalabel>
                    <input type="number" pInputText min="0" formControlName="progressiveSlap3" id="progressiveSlap3"
                      class="w-full" placeholder="Enter Slab 3"
                      [ngClass]="{ 'p-invalid': isDetailsInvalid(i, 'progressiveSlap3') }" />
                    <label for="progressiveSlap3">SLAB 3<span class="requiredLable">*</span></label>
                  </p-iftalabel>
                </p-inputgroup>
              </div>

              <!-- SLAB 3 % -->
              <div class="field col-12 md:col-2">
                <p-inputgroup>
                  <p-inputgroup-addon>
                    <i class="pi pi-percentage"></i>
                  </p-inputgroup-addon>
                  <p-iftalabel>
                    <p-inputNumber formControlName="progressiveSlap3Prc" id="progressiveSlap3Prc" [min]="0" [max]="100"
                      mode="decimal" [minFractionDigits]="0" [maxFractionDigits]="3" class="w-full"
                      placeholder="Enter Slab 3 %"
                      [ngClass]="{ 'p-invalid': isDetailsInvalid(i, 'progressiveSlap3Prc') }"></p-inputNumber>
                    <label for="progressiveSlap3Prc">SLAB 3 %<span class="requiredLable">*</span></label>
                  </p-iftalabel>
                </p-inputgroup>
              </div>

              <!-- Deliverables -->
              <div class="field col-12 md:col-2">
                <p-inputgroup>
                  <p-inputgroup-addon>
                    <i class="pi pi-file"></i>
                  </p-inputgroup-addon>
                  <p-iftalabel>
                    <input type="text" pInputText formControlName="deliverables" id="deliverables" class="w-full"
                      placeholder="Enter Deliverables"
                      [ngClass]="{ 'p-invalid': isDetailsInvalid(i, 'deliverables') }" />
                    <label for="deliverables">Deliverables<span class="requiredLable">*</span></label>
                  </p-iftalabel>
                </p-inputgroup>
              </div>

              <div class="field p-col-2 md:col-2 flex align-items-end">
                <button pButton icon="pi pi-trash" class="p-button-danger" *ngIf="i > 0"
                  (click)="removeItemFromContractDetail(i)"></button>
              </div>
              <div class="col-12">
                <hr class="my-3 mx-0 border-top-1 border-bottom-none border-300" />
              </div>
            </div>
          </div>

          <div class="p-field p-col-2 flex align-items-end">
            <button pButton label="Add Item" icon="pi pi-plus" (click)="addItemToContractDetail()"></button>
          </div>
        </div>
      </div>

      <div class="mt-4">
        <p-fieldset legend="Attachments" [toggleable]="true">
          <p-fileUpload name="attachments[]" (onSelect)="onFileSelect($event)" [multiple]="true"
            [accept]="attachmentAcceptTypes" [maxFileSize]="maxFileSize"
            [showUploadButton]="false" [showCancelButton]="false" [disabled]="isUploadingAttachments"
            chooseLabel="Choose Files">
          </p-fileUpload>

          <div class="mt-3" *ngIf="isUploadingAttachments">
            <div class="mb-2 text-600 text-sm">Uploading attachments {{ attachmentUploadProgress }}%</div>
            <p-progressBar [value]="attachmentUploadProgress"></p-progressBar>
          </div>

          <div class="mt-4 grid" *ngIf="attachments.controls.length > 0">
            <div *ngFor="let control of attachments.controls; let i = index" class="col-12 md:col-6 lg:col-4">
              <div class="flex align-items-center justify-content-between p-2 border-1 surface-border border-round">
                <span class="font-medium text-sm white-space-nowrap overflow-hidden text-overflow-ellipsis"><i
                    class="pi pi-file mr-2"></i>{{ control.get('fileName')?.value }}</span>
                <p-button icon="pi pi-times" styleClass="p-button-danger p-button-text p-button-rounded"
                  (click)="removeAttachment(i)"></p-button>
              </div>
            </div>
          </div>
        </p-fieldset>
      </div>

      <div class="flex justify-content-end gap-2 m-4 mt-6">
        <p-button label="Cancel" icon="pi pi-times" styleClass="p-button-secondary" (click)="onCancel()"></p-button>
        <p-button label="Save" icon="pi pi-check" (click)="submitForm()" [loading]="isLoading || isUploadingAttachments"></p-button>
      </div>
    </form>
  </div>
</div>
